module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-stat-cards"
  }, _vm._l((_vm.cards), function(card) {
    return _c('div', {
      key: card.filter,
      class: ['stock-stat-card', 'filter-' + card.filter, {
        active: _vm.activeFilter === card.filter
      }],
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('filter-change', card.filter)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.$emit('filter-change', card.filter)
        }
      }
    }, [_c('div', {
      class: ['stock-stat-icon', card.color]
    }, [_c('i', {
      class: card.icon + ' icon'
    })]), _vm._v(" "), _c('div', {
      staticClass: "stock-stat-info"
    }, [_c('div', {
      staticClass: "stock-stat-value"
    }, [_vm._v(_vm._s(card.value))]), _vm._v(" "), _c('div', {
      staticClass: "stock-stat-label"
    }, [_vm._v(_vm._s(card.label))]), _vm._v(" "), _c('div', {
      staticClass: "stock-stat-sublabel"
    }, [_vm._v(_vm._s(card.sublabel))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43d84fbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stock/StockStatCards.vue
// module id = 762
// module chunks = 2